<template>
  <div>
    <!-- <div v-show="!user" data-test="loader">Authenticating...</div> -->
    <p v-if="loginError">{{ loginError }}</p>
    <div v-show="user !== undefined && !user" class="welcome-screen">
      <h3 class="display-1" color="white">{{ $t('loggedOut.helloFriend') }}</h3>
      <p class="title">{{ $t('loggedOut.letsBegin') }}</p>
      <v-btn depressed medium outlined color="white" @click="login">
        {{ $t('loggedOut.loginGoogle') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { isNil } from 'lodash'
import firebase from '@firebase/app'
import { desktop as isDekstop } from 'is_js'

export default {
  data: () => ({ loginError: null }),
  computed: {
    ...mapState('authentication', ['user'])
    // ...mapState('app', ['networkOnLine', 'appTitle'])
  },
  watch: {
    user: {
      handler(user) {
        if (!isNil(user)) {
          const redirectUrl = isNil(this.$route.query.redirectUrl)
            ? '/'
            : this.$route.query.redirectUrl
          this.$router.push(redirectUrl)
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('authentication', ['setUser']),
    async login() {
      this.loginError = null
      const provider = new firebase.auth.GoogleAuthProvider()
      this.setUser(undefined)

      try {
        // Firebase signin with popup is faster than redirect
        // but we can't use it on mobile because it's not well supported
        // when app is running as standalone on ios & android
        // eslint-disable-next-line no-unused-expressions
        isDekstop()
          ? await firebase.auth().signInWithPopup(provider)
          : await firebase.auth().signInWithRedirect(provider)
      } catch (err) {
        this.loginError = err
        this.setUser(null)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.theme--light {
  &.v-card {
    background-color: transparent;
    box-shadow: none;
  }
}

.welcome-screen {
  .display-1 {
    color: #fff;
    margin-bottom: 20px;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
  }
  .title {
    color: #fff;
    margin-bottom: 20px;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
  }
}

.page-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .login-page-title {
    text-align: center;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
  }

  .login-btn {
    margin-top: 20px;
    cursor: pointer;
    padding: 5px 20px;
    border: 1px solid;
    display: inline-block;
    border-radius: 3px;
    border-color: #2c3e50;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);

    &:hover {
      color: white;
      border-color: white;
    }
  }
}
</style>

<style scoped>
.v-btn__content {
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
}
</style>
